import type { Deactivation2Config } from '@elfsight/widget-deactivation';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

const { alias } = meta;

type DeactivationProps = Omit<
  Deactivation2Config,
  'appAlias' | 'displayDeactivation' | 'deactivationURL'
>;

export function Deactivation({
  children,
  ...forwardingProps
}: DeactivationProps) {
  const { displayDeactivation, deactivationURL } = useSettings();

  return (
    <Deactivation2
      appAlias={alias}
      displayDeactivation={displayDeactivation}
      deactivationURL={deactivationURL}
      {...forwardingProps}
    >
      {children}
    </Deactivation2>
  );
}
